import { useAuth0 } from '@auth0/auth0-react';
import ComingSoon from '../../components/ComingSoon';

const HomePage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { isAuthenticated, isLoading } = useAuth0();

  if (!isAuthenticated && !isLoading) {
    return <ComingSoon />;
  }

  return null;
};

export default HomePage;
